import { REHYDRATE } from 'redux-persist';
import {
  LEADS_FETCH,
  LEADS_FETCH_BY_ID,
  LEADS_FETCH_TIMELINE_BY_ID,
  LEADS_SET_FILTERS,
  LEADS_FETCH_NOTES_BY_ID,
  LEADS_FETCH_EMAIL_TEMPLATES,
  LEADS_FETCH_EMAIL_THREAD_BY_ID,
  LEADS_FETCH_EMAIL_THREAD_CLEAR,
  LEADS_FETCH_EMAIL_BY_ID,
  LEADS_CALL_HISTORY,  
  ORG_FILTERS,
  PREDICTIVE_PROG_FEED_SUMM_FETCH,
  RATE_VRM_LOOKUP
} from '../actions';

const INIT_STATE = {
  list: [],
  list_paging: { total_rows: 0, page_size: 25, page_indx: 0 },
  lead: null,
  notes: [],
  mail: [],
  mail_thread: [],
  mail_templates: [],
  call_history: [],
  timeline: [],
  rates: {
    meta: null,
    results: []
  },
  org_filters: { parents: [], orgs: [] },
  pred_feed_summ: { all: null, callback: null, not_interested: null },
  grid_options: {
    lead: {
      crud_modal: null,
      crud_data: null,
      view: 'list',
      sort: 'asc',
      search: null,
      filters: {
      }
    }
  },
};

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LEADS_FETCH.REQUEST: {
      const { reset_filters } = action.payload
      if (reset_filters === true) {
        // console.log(reset_filters,'reset_filters')
        let filters = {}
        const { dates } = state.grid_options.lead.filters
        if (dates) {
          filters.dates = dates
        }
        return { ...state, grid_options: {
          ...state.grid_options,
          lead: {
            ...state.grid_options.lead,
            filters
          },
        } }
      }
      return { ...state }
    }
    case LEADS_FETCH.SUCCESS: {
      const { leads, total_rows, page_size, page_indx } = action.payload
      return { ...state, list: leads, list_paging: { total_rows, page_size, page_indx } }
    }
    case LEADS_FETCH_BY_ID.SUCCESS: {
      return { ...state, lead: action.payload }
    }
    case LEADS_FETCH_TIMELINE_BY_ID.REQUEST: {
      return { ...state, timeline: [] }
    }
    case LEADS_FETCH_TIMELINE_BY_ID.SUCCESS: {
      return { ...state, timeline: action.payload }
    }
    case LEADS_SET_FILTERS.REQUEST: {
      return { ...state, grid_options: {
        ...state.grid_options,
        lead: {
          ...state.grid_options.lead,
          filters: {
            ...state.grid_options.lead.filters,
            ...action.payload,
          }
        },
      } }
    }
    // case LEADS_SET_FILTERS_RESET.REQUEST: {
    //   let filters = {}
    //   const { dates } = state.grid_options.lead.filters
    //   if (dates) {
    //     filters.dates = dates
    //   }
    //   return { ...state, grid_options: {
    //     ...state.grid_options,
    //     lead: {
    //       ...state.grid_options.lead,
    //       filters
    //     },
    //   } }
    // }
    case LEADS_FETCH_NOTES_BY_ID.REQUEST: {
      return { ...state, notes: [] }
    }
    case LEADS_FETCH_NOTES_BY_ID.SUCCESS: {
      return { ...state, notes: action.payload }
    }
    case LEADS_FETCH_EMAIL_TEMPLATES.REQUEST: {
      return { ...state, mail_templates: [] }
    }
    case LEADS_FETCH_EMAIL_TEMPLATES.SUCCESS: {
      return { ...state, mail_templates: action.payload }
    }
    case LEADS_FETCH_EMAIL_BY_ID.REQUEST: {
      return { ...state, mail: [] }
    }
    case LEADS_FETCH_EMAIL_BY_ID.SUCCESS: {
      return { ...state, mail: action.payload }
    }
    case LEADS_FETCH_EMAIL_THREAD_BY_ID.REQUEST:
    case LEADS_FETCH_EMAIL_THREAD_CLEAR.REQUEST: {
      return { ...state, mail_thread: [] }
    }
    case LEADS_FETCH_EMAIL_THREAD_BY_ID.SUCCESS: {
      return { ...state, mail_thread: action.payload }
    }
    case LEADS_CALL_HISTORY.REQUEST: {
      return { ...state, call_history: [] }
    }
    case LEADS_CALL_HISTORY.SUCCESS: {
      return { ...state, call_history: action.payload }
    }
    case REHYDRATE: {
      return INIT_STATE
    }
    case ORG_FILTERS.SUCCESS: {
      return { ...state, org_filters: action.payload }
    }  
    case PREDICTIVE_PROG_FEED_SUMM_FETCH.REQUEST: {
      return { ...state, pred_feed_summ: INIT_STATE.pred_feed_summ }
    }
    case PREDICTIVE_PROG_FEED_SUMM_FETCH.SUCCESS: {
      const {
        all,
        callback,
        not_interested,
      } = action.payload
      return { ...state, pred_feed_summ: { all, callback, not_interested } }
    }
    case RATE_VRM_LOOKUP.REQUEST:
      return { ...state, rates: INIT_STATE.rates }
    case RATE_VRM_LOOKUP.SUCCESS: {
      const { meta, rates } = action.payload
      return { ...state, rates: { meta, results: rates } }
    }
    default: return { ...state };
  }
}

export default handler
